export default __webpack_public_path__ + "src/images/packages/simbambili-lodge/2cc739cdc70a984fdd08822bb18a70a8-3.jpg";